import { IntegrationsPortErrors } from 'modules/Integrations/domain'
import type { RilletIntegrationConfig } from './rillet.integration.config'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { isLiveCustomerPushToggle } from 'Integrations/integrationsConfig/common/AutoLinkCustomers/entityTypeSyncToggle.helpers'

export const rilletConfigurationLoader = async (): Promise<{
  data: RilletIntegrationConfig | null
  error: IntegrationsPortErrors | null
}> => {
  const [stored, webhookSecret, toggles] = await Promise.all([
    dashboardv99990101Client.getStoredRilletCredentials(),
    dashboardv99990101Client.getStoredRilletWebhookToken(),
    dashboardv99990101Client.getEntityTypeSyncToggles()
  ])

  const autoLinkToggle =
    toggles.data?.items.find(
      toggle =>
        toggle.integrationService === 'Rillet' &&
        isLiveCustomerPushToggle(toggle)
    ) ?? null
  const autoLinkCustomers = autoLinkToggle?.enabled ?? false
  const autoLinkSyncPermission = autoLinkToggle?.syncPermission

  if (stored.data === undefined) {
    return {
      data: {
        maskedApiKey: '',
        maskedWebhookSecret:
          webhookSecret.data?.maskedWebhookSecret?.maskedString ?? '',
        autoLinkCustomers,
        autoLinkSyncPermission
      },
      error: null
    }
  }

  return {
    data: {
      maskedApiKey: stored.data?.maskedApiKey?.maskedString ?? '',
      maskedWebhookSecret:
        webhookSecret.data?.maskedWebhookSecret?.maskedString ?? '',
      autoLinkCustomers,
      autoLinkSyncPermission
    },
    error: null
  }
}
